import { useEffect, useState } from "react";

function getTarget() {
  const now = new Date();
  const target = new Date(now);
  target.setUTCDate(target.getUTCDate() + 7);
  target.setUTCHours(0, 0, 0, 0);
  return target;
}

function useCountdown(target) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
}

export default function Urgency() {
  const [target] = useState(getTarget);
  const { d, h, m, s } = useCountdown(target);
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <section
      data-testid="urgency-section"
      className="relative py-20 sm:py-28 bg-ink-elevated border-y border-gold/20 grain overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(240,196,107,0.1),_transparent_60%)]" />
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-6">
            <div className="data-label text-gold mb-5">/ Only 7 Spots Left This Quarter</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight mb-5">
              We only take 24 new clients every 3 months.
            </h2>
            <p className="text-white/70 text-base sm:text-lg max-w-xl">
              That way, every person gets real attention — not a one-size-fits-all
              answer. Once the timer hits zero, the door closes until next quarter.
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-4 gap-3 sm:gap-6">
              {[
                { v: pad(d), l: "Days" },
                { v: pad(h), l: "Hours" },
                { v: pad(m), l: "Minutes" },
                { v: pad(s), l: "Seconds" },
              ].map((u) => (
                <div
                  key={u.l}
                  className="border border-white/15 bg-[#0A0A0A] py-6 sm:py-8 text-center"
                  data-testid={`countdown-${u.l.toLowerCase()}`}
                >
                  <div className="font-mono text-3xl sm:text-5xl text-gold tabular-nums">
                    {u.v}
                  </div>
                  <div className="mt-2 data-label">{u.l}</div>
                </div>
              ))}
            </div>
            <div className="mt-6 flex items-center justify-between font-mono text-[11px] tracking-[0.25em] uppercase">
              <span className="flex items-center gap-2 text-white/70">
                <span className="h-2 w-2 bg-gold rounded-full animate-pulse" />
                7 of 24 spots remaining
              </span>
              <a
                href="#pricing"
                data-testid="urgency-cta"
                className="text-gold hover:text-gold-light border-b border-gold/40 pb-1"
              >
                Grab Your Spot →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
